

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const GoverningLawSection = () => {
  return (
    <div>
      <Paragraph>
        This Agreement shall be governed by and construed in accordance with the
        laws of the State of Texas, without regard to its conflict of law
        principles.
      </Paragraph>

      <Paragraph>
        <Text strong>Venue and Jurisdiction</Text>
      </Paragraph>

      <Paragraph>
        Any legal action, claim, dispute, or proceeding arising out of or relating
        to this Agreement, TrackBiz, or the services provided by Club Sports
        Solutions L.L.C. shall be brought exclusively in the state or federal
        courts located in Williamson County, Texas.
      </Paragraph>

      <Alert
        message="Texas Law Applies"
        description="Both parties agree that Texas law will govern this Agreement and that disputes will be handled in the courts located in Williamson County, Texas."
        type="info"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Customer and Provider each consent to the personal jurisdiction of such
        courts and waive any objection to venue or inconvenient forum in such
        courts.
      </Paragraph>

      <Paragraph>
        Nothing in this section prevents Provider from seeking temporary,
        preliminary, or emergency injunctive relief in any court of competent
        jurisdiction when necessary to protect Provider's intellectual property,
        confidential information, security, systems, or legal rights.
      </Paragraph>
    </div>
  );
};

export default GoverningLawSection;